<template>
  <div style="padding: 15px">
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    <div class="columns is-justify-content-center root-container">
      <div class="col-sm-12 col-md-10 col-lg-8">
        <h1>Formulario de Registro</h1>
        <p>Tiene que completar todos los datos solicitados para que el registro sea exitoso</p>
        <div class="main-containers" v-show="isGeneral">
          <div class="columns">
            <div class="column">
              <h3>Información General</h3>
            </div>
            <div class="column">
            </div>
            <vs-button v-show="isCleanInformation"
                       color="primary"
                       type="filled"
                       @click="cleanInformation()"
                       class="btn btn-primary">
              Limpiar información
            </vs-button>
          </div>
          <hr/>
          <div class="general-content-margin">
            <div class="columns">
              <div class="column">
                <div class="input-wrapper">
                  <label for="identification">Apartamento</label>
                  <input v-model="identification" type="text"
                         :maxlength="20"
                         placeholder="Ingrese número de apartamento"
                         class="input-default" v-validate="'required'">
                </div>
              </div>
              <div class="column">
                <div class="input-wrapper">
                  <label for="address">Torre</label>
                  <input v-model="address" type="text"
                         :maxlength="20"
                         placeholder="Ingrese su número de torre" class="input-default"
                         v-validate="'required'">
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="input-wrapper">
                  <label for="uuid">Código de validación</label>
                  <input v-model="uuid" type="text"
                         placeholder="Ingrese su código de validación" class="input-default"
                         v-validate="'required'">
                </div>
              </div>
              <div class="column">

                <vs-button
                    icon="search"
                    color="primary"
                    type="filled"
                    class="pl-3 pr-3 mr-2"
                    @click="getPlace()">
                  Buscar
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="main-containers" v-show="isRegisterPerson">
          <RegisterPerson v-bind:receivePlaceCode="codePlace, companyCode, personList"
                          @transactionCompleted="recordData"/>
        </div>
        <div class="main-containers" v-show="isManagePerson">
          <ManagePerson v-bind:isMenu="isMenu, isAddUser, personList" @openForm="openForm" @backMenu="getPlace"
                        @openUpdatePhoto="openUpdatePhoto"/>
        </div>
        <div class="main-containers" v-show="isRegisterVehicle">
          <RegisterVehicle v-bind:receivePlaceCode="codePlace, companyCode" @transactionCompleted="recordData"/>
        </div>
        <div class="main-containers" v-show="isManageVehicle">
          <ManageVehicle v-bind:vehicle-list="vehicleList" @openForm="openForm" @openUpdatePhoto="openUpdatePhoto"/>
        </div>
        <div class="main-containers" v-show="isUpdatePhoto">
          <UpdatePhoto v-bind:objVehicle="vehicleList,  personList, codeEntity, codeVehicle"
                       @openUpdatePhoto="openUpdatePhoto" @backMenu="getPlace" @transactionCompleted="recordData"/>
        </div>
      </div>
    </div>
    <footer-page/>
  </div>
</template>

<script>
import ManagePerson from "@/views/guardian/manage-tenant/manage-person/ManagePerson";
import RegisterVehicle from "@/views/guardian/manage-tenant/manage-vehicle/RegisterVehicle";
import ManageVehicle from "@/views/guardian/manage-tenant/manage-vehicle/ManageVehicle";
import RegisterPerson from "@/views/guardian/manage-tenant/manage-person/RegisterPerson";
import UpdatePhoto from "@/views/guardian/manage-tenant/UpdatePhoto";
import FooterPage from "@/views/guardian/FooterPage";
import {configToast, TOAST_TYPES} from "@/global/toast";
import {GUARDIAN} from "@/global/api/api_guardian";

export default {
  name: "GeneralInformation",
  components: {UpdatePhoto, ManagePerson, RegisterVehicle, ManageVehicle, RegisterPerson, FooterPage},
  data: () => ({
    isLoading: false,
    codePlace: null,
    name: null,
    address: null,
    identification: null,
    uuid: null,
    personList: [],
    vehicleList: [],
    apartment: null,
    tower: null,
    isCleanInformation: false,
    isRegisterPerson: false,
    isManagePerson: false,
    isRegisterVehicle: false,
    isManageVehicle: false,
    isUpdatePhoto: false,
    isMenu: false,
    isAddUser: true,
    isGeneral: true,
    companyCode: "4821",
    codeEntity: null,
    codeVehicle: null,

  }),
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#rates_container");
      return instance.open(message, type);
    },
    getObjectPlace() {
      return {
        company: this.companyCode,
        status: "A",
        address: this.address,
        identification: this.identification,
        uuid: this.uuid
      };
    },
    cleanInformation() {
      this.codePlace = null;
      this.personList = [];
      this.vehicleList = [];
      this.isCleanInformation = false;
      this.isManagePerson = false;
      this.isManageVehicle = false;
      this.isRegisterVehicle = false;
      this.isRegisterPerson = false;
      this.address = null;
      this.identification = null;
      this.uuid = null;
    },

    recordData(value) {
      value == "person" ? (this.isRegisterPerson = false, this.isUpdatePhoto = false) : (this.isRegisterVehicle = false, this.isGeneral = true, this.isUpdatePhoto = false);
      this.getPlace();
    },

    fillData(data) {
      this.codePlace = data.info.code;
      this.personList = data.info.personList;
      this.vehicleList = data.info.vehicleList;
      this.isCleanInformation = true;
      this.isManagePerson = true;
      this.isManageVehicle = true;
      this.isRegisterVehicle = false;
      this.isRegisterPerson = false;
      this.isUpdatePhoto = false;
      this.isAddUser = true;
      this.isMenu = false;
    },
    openUpdatePhoto(value) {
      console.log(value.action);

      console.log(value.codePerson);
      console.log(value.codeVehicle);
      value.action == "vehicle" ? (
              this.isUpdatePhoto = true,
                  this.isRegisterPerson = false,
                  this.isAddUser = false,
                  this.isMenu = false,
                  this.isManagePerson = false,
                  this.isManageVehicle = false,
                  this.isRegisterVehicle = false,
                  this.codeVehicle = value.codeVehicle)
          : (this.isUpdatePhoto = true,
              this.isRegisterPerson = false,
              this.isManagePerson = false,
              this.isManageVehicle = false);
      this.codeEntity = value.codePerson;
    },
    openForm(value) {
      value == "vehicle" ? (this.isGeneral = false,
              this.isAddUser = false,
              this.isMenu = true,
              this.isManagePerson = true,
              this.isManageVehicle = false,
              this.isRegisterVehicle = true)
          : (this.isRegisterPerson = true,
              this.isManagePerson = false,
              this.isManageVehicle = false);
    },
    getPlace() {
      this.isGeneral = true;
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.toast("Debe completar todos los datos del formulario", TOAST_TYPES.ERROR);
          return;
        }
        this.codePlace = null;
        const place = this.getObjectPlace();
        this.isLoading = true;
        this.$http.get(GUARDIAN.MANAGE_PERSON.POST_PLACE, {params: place})
            .then(({data}) => {
              if (data.code > 0) {
                this.fillData(data);
                this.isLoading = false;
                return;
              }
              this.toast("Verificar los datos ingresados, no se encontró el apartamento.");
              this.cleanInformation();
              this.isLoading = false;
            });
      });
    },
  }

}
</script>

<style scoped>
.main-containers {
  background-color: white;
  padding: 20px;
  margin-top: 20px;
}

.input-wrapper {
  background-color: white;
  border: 1px solid rgba(34, 51, 84, 0.5);
  border-radius: 4px;
  position: relative;
  padding: 10px;
}

.input-wrapper input {
  border: none;
  position: relative;
  padding: 1px;
  width: 100%;
}

.input-wrapper label {
  position: absolute;
  top: -1.5ex;
  z-index: 1;
  left: 0.4em;
  background-color: white;
  padding: 0 5px;
  color: rgba(34, 51, 84, 0.5);
}

.root-container {
  min-height: calc(100vh - 101px);
}
</style>